document.addEventListener('DOMContentLoaded', function () {
  var min = 350;
  var max = 600;
  var viewerCount = Math.floor(Math.random() * (max - min + 1)) + min;
  var viewerElement = document.getElementById('viewer-count');
  if (viewerElement) {
      viewerElement.textContent = viewerCount;
  }
});